import { render } from "./TemplateLiveView.vue?vue&type=template&id=cc66a898&scoped=true"
import script from "./TemplateLiveView.vue?vue&type=script&lang=ts"
export * from "./TemplateLiveView.vue?vue&type=script&lang=ts"

import "./TemplateLiveView.vue?vue&type=style&index=0&id=cc66a898&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-cc66a898"

export default script